import { useQuery } from '@tanstack/react-query';
import { skinsService } from '../Services';
import useStores from './use-stores';

export const useGetSkins = () => {
    const { userStore } = useStores();

    return useQuery({
        queryKey: ['skins', userStore.user.partner_id],
        queryFn: () => skinsService.getSkin(),
        select: (data) => {
            const selectedSkin = data.skins.find((skin) => {
                return skin.id === userStore.user.partner_id;
            });
            return selectedSkin;
        },
    });
};
